import { InventoryUploadErrorReason } from '@thinkalpha/locates-ws-client';
import type { UploadStreamError } from 'src/admin/models/PoolInventoryUploadModel';

/**
 * Rows the backend reported as failed-to-persist across an apply's
 * streamed errors, for the done-step chip. Only `ItemsFailed` carries a
 * per-row split — fatal reasons zero the applied counts instead, so
 * their `failed` figures are not row counts and are excluded.
 */
export function failedUploadRowCount(errors: ReadonlyArray<UploadStreamError>): number {
    return errors
        .filter((error) => error.reason === InventoryUploadErrorReason.ItemsFailed)
        .reduce((sum, error) => sum + error.failed, 0);
}
